import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Check, MapPin, Clock, ArrowLeft } from "lucide-react";
import { clinic } from "../data";
import { trackGoal } from "../utils/analytics";

export default function ThankYou() {
  const goalSent = useRef(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    // Цель «Заявка отправлена» — срабатывает на странице благодарности.
    // Сам просмотр страницы досылает RouteTracker в App.js.
    // Флаг защищает от повторной отправки: в dev-режиме React StrictMode
    // прогоняет эффект дважды, и цель уходила бы в Метрику два раза.
    if (goalSent.current) return;
    goalSent.current = true;
    trackGoal("thank_you_page");
  }, []);

  return (
    <div className="thankyou" data-testid="thankyou-page">
      <div className="thankyou-card">
        <div className="thankyou-icon">
          <Check size={40} strokeWidth={3} />
        </div>

        <h1>Спасибо! Ваша заявка принята</h1>
        <p>
          Персональный куратор клиники перезвонит вам в течение 15 минут, подберёт удобное время и ответит на все вопросы.
        </p>

        <div className="thankyou-info">
          <div className="thankyou-info-row">
            <MapPin size={20} />
            <div>
              <strong>Адрес клиники</strong>
              {clinic.address}, {clinic.city}
            </div>
          </div>
          <div className="thankyou-info-row">
            <Clock size={20} />
            <div>
              <strong>Режим работы</strong>
              {clinic.workingHours}
            </div>
          </div>
        </div>

        <Link to="/" className="btn btn-outline" data-testid="thankyou-back">
          <ArrowLeft size={16} />
          Вернуться на главную
        </Link>
      </div>
    </div>
  );
}
